module.exports = __webpack_public_path__ + "img/TOMSK.5769894b.png";